import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import { IP2CalculatorRequest } from '../interface/calculator/IP2CalculatorRequest';
import { IP2CalculatorResponse } from '../interface/calculator/IP2CalculatorResponse';
import { generateQueryString } from 'src/util/helper';
import { IPriceCourtParameter } from '../interface/calculator/IPriceCourtParameters';
import { IMultiPriceCalculatorRequest } from '../interface/calculator/IMultiPriceCalculatorRequest';
import { ICurveData, IGraphDataSource } from 'src/components/common/Graphs/GraphTypes';
import { IPricingCalculatorRequest } from '../interface/calculator/IPricingCalculatorRequest';
import { IPricingCalculatorResponse } from '../interface/calculator/IPricingCalculatorResponse';
import { IBaseResponse } from '../interface/IBaseResponse';

enum PricingServiceEnum {
	getPricingParametersByCourt = '/parameters',
	calculatePrice = '/calculate-price',
	calculateP2 = '/calculate-p2',
	calculateGraph = '/calculate-graph'
}

export default class PricingService extends ApiService {
	constructor(restClient: AxiosInstance) {
		super(restClient, '/pricing');
	}

	public getPricingParametersByCourt = async (court: number, nature: number, tradeid: number): Promise<IPriceCourtParameter> =>
		await this.GET(`${PricingServiceEnum.getPricingParametersByCourt}?${generateQueryString({ court, nature, tradeid })}`);

	public postCalculatePrice = async (request: IPricingCalculatorRequest | IMultiPriceCalculatorRequest): Promise<IBaseResponse<IPricingCalculatorResponse>> =>
		await this.POST(PricingServiceEnum.calculatePrice, request);

	public postCalculateP2 = async (request: IP2CalculatorRequest): Promise<IBaseResponse<IP2CalculatorResponse>> => await this.POST(PricingServiceEnum.calculateP2, request);

	public postCalculateGraphPoints = async (request: IPricingCalculatorRequest): Promise<IGraphDataSource<ICurveData>> =>
		await this.POST(PricingServiceEnum.calculateGraph, request);
}
